module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 001.14035a61.jpg";